import { CustomNumberField } from "components/shared/form";
import VehicleOwnership from "components/shared/vehicleOwnership";
import { featureModuleTypesEnum } from "helpers/enums";
import { truckNumber } from "helpers/validators";
import React from "react";

const Markup = ({
    renderField,
    renderSelect,
    renderFuelTanks,
    renderCheckbox,
    renderFuelCards,
    renderMechanic,
    setValue,
    setCustomNumberMode,
    data = {},
    renderСolumnDispatcher,
    Button,
    ...props
}) => {
    const {
        number,
        typeId,
        brandTypeId,
        carrying,
        volume,
        ownershipType,
        ownershipBasisDocuments,
        trackerId,
        logistId,
        transportColumnId,
        comment,
        needsMaintenanceComment,
        needsUrgentMaintenance,
        isInRefuelingSyncList,
        availableFeatureModules,
        refuelingSettings,
        accessPermitIds,
        organizationName,
        ownershipDisabled,
    } = props;
    const useCustomNumber = !!data.useCustomNumber;

    return (
        <div>
            <CustomNumberField
                number={number}
                numberValidator={truckNumber}
                onCustomNumberChange={setCustomNumberMode}
                renderField={renderField}
                useCustomNumber={useCustomNumber}
            />
            {renderSelect(typeId)}
            {renderSelect(brandTypeId)}
            <VehicleOwnership
                carrying={carrying}
                data={data}
                disabled={ownershipDisabled}
                organizationName={organizationName}
                ownershipBasisDocuments={ownershipBasisDocuments}
                ownershipType={ownershipType}
                renderField={renderField}
                renderSelect={renderSelect}
                setValue={setValue}
                volume={volume}
            />
            {renderSelect(logistId)}
            {renderSelect(trackerId)}
            {renderSelect(transportColumnId)}
            {availableFeatureModules.includes(featureModuleTypesEnum.RefuelingPlanning) &&
                !refuelingSettings.hideRefuelingPlanning &&
                renderCheckbox(isInRefuelingSyncList)}
            {renderMechanic()}
            {renderСolumnDispatcher()}
            {renderField(comment)}
            {renderField(needsMaintenanceComment)}
            {renderCheckbox(needsUrgentMaintenance)}
            {renderSelect(accessPermitIds)}
            {renderFuelCards()}
            {renderFuelTanks()}
            {!!Button && <Button />}
        </div>
    );
};

export default Markup;
